import isPropValid from "@emotion/is-prop-valid";
import { css, styled, type Theme } from "@mui/material";
import React from "react";
import { Link, type LinkProps } from "react-router-dom";

type Props = React.PropsWithoutRef<LinkProps> &
	React.RefAttributes<HTMLAnchorElement> & {
		isWithIcon?: boolean;
		isUnderlined?: boolean;
	};

const baseLinkStyles = (props: { theme: Theme }) => css`
  text-decoration: inherit;
  color: ${props.theme.palette.primary.main};
  font-weight: 500;
  line-height: 1;
  vertical-align: middle;

  &:focus {
    outline: none;
  }
`;

const StyledLink = styled(Link, { shouldForwardProp: isPropValid })<{
	$isUnderlined?: boolean;
}>`
  ${baseLinkStyles}
  ${(props) => props.$isUnderlined && "text-decoration: underline;"}
  display: inline-flex;
`;

const StyledWrapper = styled("div")`
  a {
    display: flex;
    align-items: center;
  }

  svg {
    width: 16px;
    height: auto;
    margin-right: ${(props) => props.theme.spacing(1)};
  }
`;

export const UnstyledLink = React.forwardRef<HTMLAnchorElement, Props>(
	(props, ref) => {
		const { isWithIcon, isUnderlined, ...rest } = props;

		return isWithIcon ? (
			<StyledWrapper>
				<StyledLink
					ref={ref}
					tabIndex={-1}
					$isUnderlined={isUnderlined}
					{...rest}
				>
					{props.children}
				</StyledLink>
			</StyledWrapper>
		) : (
			<StyledLink
				ref={ref}
				tabIndex={-1}
				$isUnderlined={isUnderlined}
				{...rest}
			/>
		);
	},
);
